import {useAppSelector} from "@Hooks/selector/useAppSelector";

export default function useCompanyMainTransportType() {
    return useAppSelector((state) => state?.page.companyMainTransportType)
}